import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { vuetifyIcons } from '~/utils/vuetify-icons';

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({ icons: vuetifyIcons });
  app.vueApp.use(vuetify);
});
